
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4>Kontakte durch die Kirche
    </h4> <p>
Es ist nicht seine erste Tat. Anfang der Neunzigerjahre hat William W. begonnen, die evangelisch-methodistische Kirche zu besuchen. Wohl weniger aus spiritueller Überzeugung, sondern um Kontakte zu knüpfen. So lernt er auch ein Paar mit vier Kindern kennen. Es entwickelt sich eine enge Beziehung, mit 21 Jahren kommt W. als Untermieter bei ihnen unter. Er nutzt das Vertrauen der Familie aus, missbraucht die vier Minderjährigen im Haus sexuell, vergeht sich auch am Patenkind der Eltern.
    </p><p>
Als er im Dezember 1996 auffliegt, gibt das Bezirksamt Aarau ein psychiatrisches Gutachten in Auftrag, das erste von vielen. Zwei Ärzte müssen ergründen, was den jungen Mann zu den schweren Übergriffen getrieben hat. Sie diagnostizieren eine «kombinierte Persönlichkeitsstörung mit narzisstischen und unreifen Anteilen». Und gehen von Pädophilie aus.
    </p><p>
Das Bezirksgericht Aarau verurteilt W. im Mai 1999 wegen mehrfacher Schändung und mehrfachen sexuellen Handlungen mit Kindern. Der 26-Jährige kommt mit einer bedingten Zuchthausstrafe von 18 Monaten davon. Zudem muss er eine Therapie besuchen. Die beiden Gutachter bezweifeln, dass diese Erfolg haben wird. Für William W. erscheine die Behandlungsprognose «eher ungünstig», halten sie fest. Sollte der Mann erneut in engen Kontakt mit Kindern kommen, so sei die Rückfallgefahr «sehr wahrscheinlich». Sieben Jahre später trifft die Prognose ein. Dann missbraucht W. die achtjährige Selina.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;